import { ProjectFestival } from '@/domain/project-festival/entities/project-festival.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  project: ProjectFestival;
};

export const editProjectFestival = createAppAsyncThunk(
  'projectFestival/editProjectFestival',
  async (
    params: Params,
    { extra: { projectFestivalGateway, snackbarGateway } },
  ): Promise<void> => {
    try {
      await projectFestivalGateway.edit(params.project);
      showSnackbarSuccess(snackbarGateway);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('EditProject.Message.error'));
}

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('EditProject.Message.success'));
}
